<script lang="ts">
  import { Options } from "../../../shared/wspayload";
  import { messageInfo } from "../store";

    export let group: any[];
    export let values: [string, any][];

    /**
     * Unchecks “privacy” when “privacyLed” is checked and vice versa
     * @param event when check or uncheck ckeckbox
     * @param value of enum Options
     */
    function handleCheckboxChange(event: Event, value: number) {
        const isChecked = (event.target as HTMLInputElement).checked

        if (value === Options.privacy && isChecked) {
            messageInfo.update(info => {
                info.options = info.options.filter(option => option != Options.privacyLed)
                return info
            })
        } else if (value === Options.privacyLed && isChecked) {
            messageInfo.update(info => {
                info.options = info.options.filter(option => option != Options.privacy)
                return info
            })
        }
    }
</script>

<main>
    {#each values as value}
        <div class="form-check form-switch mb-3">
            <label class="form-check-label">
                <input
                    type="checkbox"
                    class="form-check-input"
                    role="switch"
                    bind:group
                    value={value[1]}
                    on:change={(event) => handleCheckboxChange(event, value[1])}
                />
                {value[0]}
            </label>
        </div>
    {/each}
    {#if $messageInfo.options.includes(Options.privacyLed)}
        <div class="alert">
            Merci d'éteindre la LED avant de commencer le test.
        </div>
    {/if}
</main>

<style>
    div {
        font-size: 16px;
    }
    .alert {
        font-weight: bold;
    }
</style>
